import React from "react";
import Project from "./index";

export function ProjectInPreparation() {
  return <Project status="En préparation" />;
}
